<script>
export default {
    name: 'HeaderBox'
}
</script>

<template>
<div class="header-box-wrapper">
  <slot/>
</div>
</template>

<style scoped lang="scss">
.header-box-wrapper {
  background: #F4F4F4;
  padding: 4px;
  font-weight: bold;
}
</style>
